import React, { useEffect } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import logo from "../logo-400.jpg";
import { useQueryClient } from "react-query";
import { useAuthDispatch, useAuthState } from "../context/AuthContext";

const LogoutPage = () => {

    const navigate = useNavigate();
    const queryClient = useQueryClient();
    const { contactPerson } = useAuthState();
    const dispatch = useAuthDispatch(); 

    useEffect(() => {
        queryClient.clear();
        if (contactPerson) {
            dispatch('CLEAR_CONTACT');
        }
        dispatch("LOGOUT");
        navigate("/logout");
    }, [])

    return (
        <div className="logout-box">
            <Container style={{ height: "100%" }}>
                <Row className="h-100 align-items-center text-center justify-content-center" >
                    <Col xs="8" md="6" xl="6" className="border-right">
                        <img src={logo} alt="logo" className="img-fluid" style={{marginLeft: "auto", marginRight: "auto"}} />
                    </Col>
                    <Col xs="12" md="6" xl="6">
                        <h1 className="text-white">Sie haben sich erfolgreich abgemeldet!</h1>
                        <p className="mt-4"><b>Vielen Dank, dass Sie das ENERGO Managementportal benutzt haben</b></p>
                        <Button variant="warning" className="btn-lg mt-3" onClick={() => navigate('/')}>Zum Login</Button>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
export default LogoutPage;